export default "__VITE_PUBLIC_ASSET__2a23d7cb__"